import React from "react";

const SiteInfo = () => {
  return (
    <div class="hero min-h-screen w-90 bg-base-200">
      <div class="hero-content flex-col lg:flex-row justify-center align-center">
        <img src="https://i.ibb.co/64gYqYk/download.jpg" />
        <div className=" ">
          <h1 class="text-2xl font-bold">About Us</h1>
          <span class="">
            We Provide Best Quality computer parts with demand and delivered
            with in a time . We have some minimum ordered items . So just
            Explore it !!! Hope a good journey with Us{" "}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SiteInfo;
